(() => {
  const normalizeId = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  const buildToc = (articleElement) => {
    const content = articleElement.querySelector('[data-article-content]');
    if (!content) return;

    const tocTargets = articleElement.querySelectorAll('[data-article-toc]');
    if (!tocTargets.length) return;

    const headings = Array.from(content.querySelectorAll('h2, h3, h4, h5, h6'));

    if (!headings.length) {
      articleElement.querySelectorAll('[data-article-toc-root]').forEach((root) => {
        root.style.display = 'none';
      });
      return;
    }

    const idMap = new Map();
    headings.forEach((heading, index) => {
      const level = heading.tagName.toLowerCase();
      const rawText = heading.textContent || `${level}-${index + 1}`;
      let idBase = normalizeId(rawText);
      if (!idBase) idBase = `article-heading-${index + 1}`;

      const count = idMap.get(idBase) || 0;
      idMap.set(idBase, count + 1);
      const id = count === 0 ? idBase : `${idBase}-${count + 1}`;
      heading.id = id;
      heading.setAttribute('data-toc-level', level);
    });

    tocTargets.forEach((tocTarget) => {
      const fragment = document.createDocumentFragment();
      headings.forEach((heading) => {
        const level = heading.tagName.toLowerCase();
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent || heading.id;
        link.className = `article-summary-toc__item article-summary-toc__item--${level}`;
        fragment.appendChild(link);
      });

      tocTarget.innerHTML = '';
      tocTarget.appendChild(fragment);
    });

    const tocLinks = Array.from(articleElement.querySelectorAll('.article-summary-toc__item'));

    const setActiveById = (id) => {
      if (!id) return;
      tocLinks.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('is-active', isActive);
      });
    };

    const syncFromHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash) setActiveById(hash);
    };

    syncFromHash();
    window.addEventListener('hashchange', syncFromHash);

    if ('IntersectionObserver' in window) {
      const headingObserver = new IntersectionObserver(
        (entries) => {
          let nearest = null;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!nearest || entry.boundingClientRect.top < nearest.boundingClientRect.top) {
                nearest = entry;
              }
            }
          });
          if (nearest && nearest.target && nearest.target.id) {
            setActiveById(nearest.target.id);
          }
        },
        {
          rootMargin: '-20% 0px -65% 0px',
          threshold: [0, 1],
        }
      );

      headings.forEach((heading) => headingObserver.observe(heading));
    }
  };

  document.querySelectorAll('.article').forEach((articleElement) => {
    buildToc(articleElement);
  });

  // Author bio modal
  function openAuthorModal(modal) {
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    const close = modal.querySelector('[data-author-bio-close]');
    if (close) close.focus();
  }

  function closeAuthorModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-author-bio-trigger]');
    if (trigger) {
      const id = trigger.dataset.authorBioTrigger;
      openAuthorModal(document.getElementById(id));
      return;
    }
    if (e.target.closest('[data-author-bio-close]')) {
      const modal = e.target.closest('.author-bio-modal');
      closeAuthorModal(modal);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.author-bio-modal:not([hidden])').forEach(closeAuthorModal);
    }
  });
})();
